import React, { useState } from "react";

const DownloadReportButton = ({
  buttonText = "Continue",
  onContinue = () => {},
  onExcel = () => {},
  confirmMessage = "Are you sure you want to continue?",
  confirmTitle = "Save Section",
  iconSrc = "/valid.svg",
  checkDisabled = false,
}) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="relative w-full md:w-auto flex justify-center md:justify-end">
      {/* Continue Button */}
      <button
        onClick={(e) => {
          e.preventDefault();
          setShowPopup(true);
        }}
        className={`flex w-full md:w-auto items-center justify-center space-x-2 ${
          checkDisabled
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-white text-black"
        } font-medium py-2 px-4 rounded-full text-sm`}
        disabled={checkDisabled}
      >
        <span>{buttonText}</span>
      </button>

      {/* Popover */}
      {showPopup && (
        <div className="absolute bottom-full mb-3 z-50 w-[90vw] md:w-96 bg-[#005A9C] border border-gray-300 rounded-lg shadow-md p-4">
          {/* Title and Close Button Row */}
          <div className="flex justify-between items-center text-white">
            <div className="flex items-center">
              <img src={iconSrc} alt="Icon" className="w-8 h-8 mr-2" />
              <h2 className="text-md font-medium">{confirmTitle}</h2>
            </div>
            <button
              onClick={() => setShowPopup(false)}
              className="text-white hover:text-gray-300 transition"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Message */}
          <p className="text-xs mt-2 text-white">{confirmMessage}</p>

          {/* Action Buttons */}
          <div className="flex text-xs justify-end space-x-2 mt-4 flex-wrap">
            <button
              onClick={() => {
                onExcel();
                setShowPopup(false);
              }}
              className="px-4 py-1 font-medium bg-white text-black rounded-full"
            >
              Download Excel
            </button>
            <button
              onClick={() => {
                setShowPopup(false);
                onContinue(); // Use the prop callback
              }}
              className="px-4 py-1 font-medium bg-white text-black rounded-full"
            >
              Download PDF
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadReportButton;
